import React from "react";
import Header from "../components/Header";

const ThankYouPage = () => {
  return (
    <>
      <Header />
      <div className="flex items-center justify-center min-h-screen py-32">
        <div className="max-w-2xl p-6 sm:p-10 w-full text-center">
          <h1 className="text-4xl font-bold mb-4">Thank You for Your Order!</h1>
          <p className="text-lg mb-8">
            We appreciate your business. Your order has been placed
            successfully.
          </p>
          <div className="mb-4">
            <h2 className="text-2xl font-semibold">Order Details</h2>
            {/* Add more order details here if needed */}
            <p>You will receive an email with your order details</p>
            <p>Order Date: {new Date().toLocaleDateString()}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThankYouPage;
